import { getAudioUrl, getCroppedImageUrl, getDocumentUrl, getImageUrl, getScaledToFillImageUrl, getScaledToFitImageUrl, getVideoUrl, getShapeUrl, } from './media/helpers.js';
export { VideoResolution, decodeText } from './media/helpers.js';
export const media = {
    getCroppedImageUrl,
    getScaledToFillImageUrl,
    getScaledToFitImageUrl,
    getImageUrl,
    getVideoUrl,
    getAudioUrl,
    getDocumentUrl,
    getShapeUrl,
};
